import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/* API */
import ReservationService from 'api/ReservationService';

/* Layout */
import PrimaryButton from 'util/PrimaryButton';
import LoadingSpinner from 'util/LoadingSpinner';
import { Container, Row, Col } from 'react-bootstrap';

/* Asset */
import checkCircle from 'assets/image/checkCircle.svg';
import cross from 'assets/image/cross.svg';

const ReservationConfirmComponent: React.FC = () => {
  const didConfirmRef = useRef<boolean>(false);
  const { reservationId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [tenpoCode, setTenpoCode] = useState<string>();
  const [hasReservationConfirmed, setHasReservationConfirmed] = useState(false);
  const [isReservationConfirmSuccess, setIsReservationConfirmSuccess] = useState(false);
  const [isReservationCancelled, setIsReservationCancelled] = useState(false);

  useEffect(() => {
    const postReservationConfirm = async () => {
      try {
        // 予約確定を行うかまたは既に予約確定されているか確認するために仮予約を取得
        const reservationDetail = await ReservationService.getReservation({
          reservationId: reservationId || '',
        });
        // 表示を切り替えるために取得できたか判定
        if (!reservationDetail.reservationId) return;
        setIsReservationConfirmSuccess(true);
        setTenpoCode(reservationDetail.tenpoCode);

        // 予約キャンセルの処理
        if (reservationDetail.reservationCancelled === 1) {
          setIsReservationCancelled(true);
          return;
        }
        // 予約確定済みの処理
        if (reservationDetail.reservationStatusCode === 1) {
          setHasReservationConfirmed(true);
          return;
        }
        // StrictModeで確定処理が2回行われないようにrefで確定済みを判定
        if (didConfirmRef.current === false) {
          didConfirmRef.current = true;
          // 予約確定・Googleカレンダー登録・SMS送信
          const result = await ReservationService.confirmReservation(reservationId || '');
          setTenpoCode(result.tenpoCode);
        }
      } catch (error) {
        setIsReservationConfirmSuccess(false);
      } finally {
        setIsLoading(false);
      }
    };
    postReservationConfirm();
  }, []);

  const handleClickReservationConfirm = () => {
    navigate(`/reservation-detail/${reservationId}`);
  };

  const handleClickNavigateToForm = () => {
    navigate(`/form/${tenpoCode}`);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!tenpoCode) {
    navigate('/404');
  }

  return (
    <Container className="mt-4">
      <Row className="justify-content-center">
        <Col xs={9} className="border py-3">
          <div className="text-center p-3">
            <img
              src={isReservationConfirmSuccess && !isReservationCancelled ? checkCircle : cross}
              alt=""
            />
          </div>
          {isReservationConfirmSuccess ? (
            <div className="text-left ps-5">
              <div>
                {isReservationCancelled
                  ? '来店予約はキャンセル済みです。'
                  : hasReservationConfirmed
                    ? 'こちらの予約は確定済みです。'
                    : '来店予約を受け付けました。'}
                <br />
              </div>
              <p className="pe-4"> 詳細は下記のボタンからご確認ください。</p>
            </div>
          ) : (
            <p className="text-left px-5">
              予約の確定に失敗しました。
              <br />
              予約を最初からやり直してください。
            </p>
          )}
        </Col>
        <Col xs={9} className="text-center pt-3">
          {isReservationConfirmSuccess ? (
            <PrimaryButton
              label="予約詳細の確認はこちら"
              type="button"
              className="w-75 mt-3"
              onClick={handleClickReservationConfirm}
            />
          ) : (
            <PrimaryButton
              label="戻る"
              type="button"
              className="w-75 mt-3"
              onClick={handleClickNavigateToForm}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ReservationConfirmComponent;
